import { makeStyles, Snackbar } from "@material-ui/core";
import Select from "react-select";
import makeAnimated from "react-select/animated";

import React, { useEffect, useState } from "react";
import MuiAlert from "@material-ui/lab/Alert";
import { useDispatch, useSelector } from "react-redux";

import { getAllWarehousesManager } from "../reduxSaga/actions";
import { Autocomplete } from "@material-ui/lab";
import WarehouseService from "../services/WarehouseService";
import getCurrentUserId from "../reduxSaga/sagas/requests/currentUserId";

const useStyles = makeStyles((theme) => ({
  fab: {
    position: "fixed",
    bottom: 20,
    right: 20,
  },
  familyContainer: {
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(3),
    display: "flex",
    justifyContent: "space-between",
  },

  autoComplete: {
    width: "fit-content",
  },

  container: {
    borderRadius: 10,
    boxShadow: "0 3px 5px 2px rgba(18,131,255,0.87)",
    width: 500,
    height: 450,
    backgroundColor: "white",
    position: "absolute",
    top: -30,
    bottom: 0,
    left: -0,
    right: 0,
    margin: "auto",
    [theme.breakpoints.down("sm")]: {
      width: "100vw",
      height: "100vh",
    },
  },
  form: {
    padding: theme.spacing(2),
  },
  item: {
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(3),
  },

  cancelAndAddButtom: {
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(5),
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  input: {
    "&::placeholder": {
      fontStyle: "italic",
    },
  },
}));

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const EditRealDeviseWarehouse = ({
  setOnEditDeviseWarehouse,
  oldDeviseWarehouseData,
}) => {
  const dispatch = useDispatch();
  const [selectedOptionWarehouseManager, setSelectedOptionWarehouseManager] =
    useState(null);
  const [warehouseManagerId, setWarehouseManagerId] = useState([]);
  const [allManagers, setAllManagers] = useState([]);
  const [listManagersId, setListManagersId] = useState([]);
  const warehousesManager = useSelector(
    (state) => state.staff.warehousesManager.success
  );
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();
  const classes = useStyles();
  const [open, setOpen] = useState(true);
  const [openAlert, setOpenAlert] = useState(false);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [oldWarehouseManagerId, setOldWarehouseManagerId] = useState(0);
  const [warehouseValue, setWarehouseValue] = useState(0);
  const animatedComponents = makeAnimated();

  const [name, setName] = useState();
  const [ref, setRef] = useState();
  const [desc, setDesc] = useState();
  const [selectedOptionDevis, setSelectedOptionDevis] = useState(null);
  const [deviseChoosen, setDeviseChoosen] = useState(null);
  const [allCurrencies, setAllCurrencies] = useState([
    { value: "TND", label: "DNT" },
    { value: "EUR", label: "Euro" },
    { value: "USD", label: "US Dollar" },
    { value: "AED", label: "United Arab Emirates Dirham" },
    { value: "CAD", label: "Canadian Dollar" },
    { value: "CNY", label: "Chinese Yuan" },
  ]);
  const [deviseSelectPlaceHolder, setDeviseSelectPlaceHolder] =
    useState("Choisir...");
  const styles = {
    container: (base) => ({
      ...base,
      flex: 1,
    }),
  };
  // let navigate = useNavigate();

  useEffect(() => {
    setRef(oldDeviseWarehouseData.warehouseReference);
    setName(oldDeviseWarehouseData.oldWarehouseName);
    setDesc(oldDeviseWarehouseData.oldWarehouseDesc);
  }, []);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenAlert(false);
  };

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const onCancelButtonHandler = () => {
    setOpen(false);
    setOnEditDeviseWarehouse(false);
  };

  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };

  const onAddRealWarehouse = () => {
    if (name === "") {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur :le champ du nom est vide ! ");
    }
    if (ref === "") {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur :le champ du reference est vide ! ");
    } else {
      WarehouseService.setWarehouseDevise(
        getCurrentUserId(),
        oldDeviseWarehouseData.idWarehouse,
        deviseChoosen,
        deviseSelectPlaceHolder
      )
        .then((response) => {
          console.log("response", response);
          if (response.data["Warehouse"]) {
            setOpenSuccessAlert(true);
            setSuccessAlertText("Mise à jour avec succées");
            setTimeout(() => {
              window.location.reload(false);
            }, 2000);
          } else {
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur :erreur serveur ");
          }
        })
        .catch((e) => {
          console.log("error", e);
        });
    }
  };

  const onChangeSelectedDevis = (selectedOptionn) => {
    setSelectedOptionDevis(selectedOptionn.value);
    setDeviseChoosen(selectedOptionn.value);
    setDeviseSelectPlaceHolder(selectedOptionn.label);
  };
  return (
    <>
      <div class="modal fade" id="devise-warehouse">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header bg-black">
              <h4 class="modal-title">Modifier le dépôt</h4>
            </div>
            <div class="modal-body">
              <div className="col-sm-12">
                <div className="form-group">
                  <label>Devise</label>
                  <Select
                    styles={styles}
                    closeMenuOnSelect={true}
                    components={animatedComponents}
                    defaultValue={selectedOptionDevis}
                    onChange={onChangeSelectedDevis}
                    options={allCurrencies}
                    placeholder={deviseSelectPlaceHolder}
                  />
                </div>
              </div>
            </div>
            <div class="modal-footer justify-content-between">
              <button
                type="button"
                onClick={onCancelButtonHandler}
                class="btn btn-light"
                data-dismiss="modal"
              >
                Close
              </button>

              <button
                type="button"
                onClick={onAddRealWarehouse}
                class="btn btn-light"
              >
                Confirmer
              </button>
            </div>
          </div>
        </div>
      </div>

      <Snackbar
        open={openAlert}
        autoHideDuration={4000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleClose} severity="success">
          Ajout avec success !
        </Alert>
      </Snackbar>
      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>

      <Snackbar
        open={openErrorAlert}
        autoHideDuration={4000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </>
  );
};

export default EditRealDeviseWarehouse;
